import { Container, Navbar, Nav, NavDropdown, Form } from "react-bootstrap";
import { S3_URL } from "../services/Constants";
import { componentIsVisible, validateAndSanitizeUrl } from "../util/common";
import { NBQH, NBDTH, NBRMH, NBRH, NBAH, NBSH } from "../util/component-codes";
import { useContext } from "react";
import UserContext from "../context/user-context";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";

import { useOktaAuth } from "@okta/okta-react";
const Header = () => {
  const { oktaAuth } = useOktaAuth();
  const logout = async () => {
    oktaAuth.signOut();
  };

  const [user] = useContext(UserContext);

  const getUserInitials = () => {
    let userInfoFromOkta = Cookies.get("userInfoFromOkta");
    if (!userInfoFromOkta) {
      return "";
    }
    let userInfo = JSON.parse(Cookies.get("userInfoFromOkta"));
    let firstName = userInfo?.given_name || "";
    let lastName = userInfo?.family_name || "";
    return (firstName[0] || "") + (lastName[0] || "");
  };

  return (
    <Navbar expand="lg">
      <Container fluid className="navContainer">
        <Navbar.Brand as={Link} to="/">
          <img src={`${validateAndSanitizeUrl(S3_URL)}idph-logo.png`} className="headerLogo" alt=""></img>
        </Navbar.Brand>
        <Navbar.Collapse id="navbarScroll">
          <Nav className="leftSection" navbarScroll>
            <Nav.Link className="navbarScrollDropdown" as={Link} to="/">
              Dashboard
            </Nav.Link>
            {componentIsVisible(NBQH, user) && (
              <NavDropdown title="Queues" className="navbarScrollDropdown">
                <NavDropdown.Item as={Link} to="/masterQueue">
                  eLR Master Queue
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/errorMessageQueue">
                  eLR Error Messages
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/discardQueue">
                  eLR Discard Queue
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/eicrMasterQueue">
                  eICR Master Queue
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/eicrErrorMessageQueue">
                  eICR Error Messages Queue
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/eicrDiscardQueue">
                  eICR Discard Queue
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/duplicateMessageQueue">
                  All Duplicate Message Queue
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/unknownFacilities">
                  All Unknown Facility
                </NavDropdown.Item>
              </NavDropdown>
            )}
            {componentIsVisible(NBDTH, user) && (
              <NavDropdown title="Data Tables" className="navbarScrollDropdown">
                <NavDropdown.Item as={Link} to="/LOINCCodes">
                  LOINC Table
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/AOELoincCodes">
                  AOE LOINC Table
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/reportingLoincCodes">
                  Reporting LOINC Table
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/SNOMEDCodes">
                  SNOMED Table
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/conditions">
                  Condition Table
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/facilities">
                  Sending Facility Table
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/performingFacilities">
                  Performing Facility Table
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/codeSets">Code Sets</NavDropdown.Item>
              </NavDropdown>
            )}
            {componentIsVisible(NBRMH, user) && (
              <NavDropdown title="Rules" className="navbarScrollDropdown">
                <NavDropdown.Item  as={Link} to="/rules">
                  Rules Management
                </NavDropdown.Item>
              </NavDropdown>
            )}
            {componentIsVisible(NBRH, user) && (
              <Nav.Link className="navbarScrollDropdown"  as={Link} to="/reporting">
                Reporting
              </Nav.Link>
            )}
            {componentIsVisible(NBAH, user) && (
              <NavDropdown title="Admin" className="navbarScrollDropdown">
                <NavDropdown.Item  as={Link} to="/userRoleManagement">
                  Users
                </NavDropdown.Item>
                <NavDropdown.Item  as={Link} to="/rolesAndPermissions">
                  Roles
                </NavDropdown.Item>
                <NavDropdown.Item  as={Link} to="/logs">Logs</NavDropdown.Item>
              </NavDropdown>
            )}
            {componentIsVisible(NBSH, user) && (
              <NavDropdown title="Settings" className="navbarScrollDropdown">
                <NavDropdown.Item  as={Link} to="/codeSetNormalization">
                  Code Set Normalization
                </NavDropdown.Item>
                <NavDropdown.Item  as={Link} to="/snomedNormalization">
                  SNOMED Normalization
                </NavDropdown.Item>
                <NavDropdown.Item  as={Link} to="/configurations">
                  Configurations
                </NavDropdown.Item>
                <NavDropdown.Item  as={Link} to="/picklistValueConfiguration">
                Picklist Value Configuration
                </NavDropdown.Item>
              </NavDropdown>
            )}
          </Nav>
          <Form className="rightSection">
            <Navbar.Brand as={Link} to="/userProfile" style={{ marginRight: "0px" }}>
              <div
                style={{
                  width: "45px",
                  height: "45px",
                  backgroundColor: "#0365C0",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span style={{ color: "#fff", fontWeight: "bold" }}>
                  {getUserInitials()}
                </span>
              </div>
            </Navbar.Brand>
            <Nav.Link
              className="navbarScrollDropdown"
              style={{ marginLeft: "0px", marginRight: "0px" }}
              onClick={logout}
            >
              Logout
            </Nav.Link>
          </Form>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;